<cx-generic-link id="generic-link"
                 tabindex="-1"
                 [url]="getURL({cxRoute: 'product', params: product} | cxUrl)"
                 class="d-block"
                 [attr.aria-label]="'productDetails.productDetailsPage' | cxTranslate: {productName: product.name}"
                 (mousedown)="this.eddlTrackProductClicked(product, false)"
                 (touchstart)="this.eddlTrackProductClicked(product, true)">
  <udex-tile hide-shadow="true"
             tabindex="-1">
    <cx-media [container]="productImage"
              [attr.aria-label]="'productDetails.productLogo' | cxTranslate"
              [alt]="altText"
              class="udex-mb-24"
              tabindex="-1"></cx-media>
    @if (!!certification && !isSapProduct) {
      <h5
        class="subtitle udex-mb-8"
        aria-hidden="true"
        [attr.aria-label]="'productDetails.certification' | cxTranslate">{{ certification }}</h5>
    }
    @if (isSapProduct) {
      <div
        class="d-flex align-items-center"
        aria-hidden="true"
        [attr.aria-label]="'productDetails.sapProduct' | cxTranslate">
        <span class="blue-line d-block udex-mb-8"></span>
        <h5 class="subtitle udex-mb-8">{{ 'productDetails.sapProduct' | cxTranslate }}</h5>
      </div>
    }
    <ui5-title level="H4"
               aria-hidden="true"
               [attr.aria-label]="'productDetails.productName' | cxTranslate"
               wrapping-type="Normal"
               class="heading__medium--xxs  udex-mb-12"> {{ product.name }}
    </ui5-title>
    @if (!!mediumDescription) {
      <dcp-limited-text
        [charLimit]="255"
        [minimumHiddenText]="0"
        [showMoreOption]="false"
        [text]="mediumDescription"
        [attr.aria-label]="'productDetails.teaserText' | cxTranslate"
        aria-hidden="true"
        class="d-inline-block body--xs udex-mb-8">
      </dcp-limited-text>
    }
    @if (!!productUtilitiesService.hasFreeTrialTransactionType(product)) {
      <udex-tag
        text="{{'productDetails.freeTrial' | cxTranslate}}"
        design="Grey"
        read-only="true"
        tabindex="-1"
        class="d-block position-absolute"
        [accessible-role]="'productDetails.freeTrialAvailable' | cxTranslate"
        aria-hidden="true"></udex-tag>
    }
  </udex-tile>
</cx-generic-link>
